import { Icon, Tag } from '@blueprintjs/core'

import type { Store } from '../store'

/**
 * Bottom status strip (SolidWorks style): units, active tool, selection
 * count, regen state, backend connection.
 */
export function StatusBar({ store }: { store: Store }) {
  const nSel = (() => {
    const sel = store.selection
    if (!sel) return 0
    if (sel.kind === 'operation') {
      const op = store.job.operations.find((o) => o.id === sel.id)
      return op ? op.faces.length + op.seamPairs.length * 2 : 0
    }
    return 1
  })()
  const tool = store.job.cell.tool
  const regenPending = store.job.operations.some((o) => o.regenState === 'needsRegen')

  return (
    <div className="statusbar">
      <StatusItem icon="translate">mm</StatusItem>
      <StatusItem icon="wrench">
        {tool ? `${tool.vendor} ${tool.part}` : 'no tool'}
      </StatusItem>
      <StatusItem icon="map-marker">world</StatusItem>
      <StatusItem icon="selection">{nSel} selected</StatusItem>
      <StatusItem icon={regenPending ? 'refresh' : 'tick'}>
        <Tag minimal intent={regenPending ? 'warning' : 'success'}>
          {regenPending ? 'regen needed' : 'up to date'}
        </Tag>
      </StatusItem>
      <div className="statusbar-right">
        <StatusItem icon={store.apiConnected ? 'cloud' : 'cloud-download'}>
          <Tag minimal intent={store.apiConnected ? 'success' : 'danger'}>
            {store.apiConnected ? 'api ok' : 'api offline'}
          </Tag>
        </StatusItem>
      </div>
    </div>
  )
}

function StatusItem({ icon, children }: { icon: 'translate' | 'wrench' | 'map-marker' | 'selection' | 'refresh' | 'tick' | 'cloud' | 'cloud-download'; children: React.ReactNode }) {
  return (
    <div className="statusbar-item">
      <Icon icon={icon} size={12} />
      <span>{children}</span>
    </div>
  )
}
